import { gql } from '@apollo/client'
import { graphql } from '@/gql'

export const FORM_FIELD_ENTRY_FRAGMENT = graphql(`
  fragment FormFieldEntry on FormFieldEntry {
    id
    value
    humanReadableValue
    formFieldId
    employeeId
    productId
    active
  }
`)

export const FORM_FIELD_WITH_LATEST_ENTRY_FRAGMENT = graphql(`
  fragment FormFieldWithEntry on FormField {
    id
    companyId
    objectType
    fieldType
    name
    localizedName
    helpText
    localizedHelpText
    uniqueValue
    defaultValue
    required
    sensitive
    order
    metadata
    fieldGroupId
    productTypeIds
    formFieldOptions(orderBy: ORDER_ASC, condition: { active: true }) {
      nodes {
        id
        localizedValue
        value
        order
      }
    }
    formFieldEntries(first: 1, orderBy: CREATED_AT_DESC, condition: $condition)
      @include(if: $includeEntry) {
      nodes {
        ...FormFieldEntry
      }
    }
  }
`)

export const FORM_FIELD_FRAGMENT = graphql(`
  fragment FormField on FormField {
    id
    companyId
    customId
    objectType
    fieldType
    name
    active
    localizedName
    helpText
    localizedHelpText
    agreementText
    localizedAgreementText
    uniqueValue
    defaultValue
    required
    sensitive
    multiple
    changesMustBeApproved
    approverUserIds
    approverGroupIds
    approverSystemFieldIds
    approverFormFieldIds
    supportsFutureData
    order
    metadata
    fieldGroupId
    productTypeIds
    departmentTypeIds
    excludedRoleIds
    formFieldsByParentFormFieldId(
      orderBy: ORDER_ASC
      condition: { active: true }
    ) {
      nodes {
        id
        fieldType
        name
        localizedName
        metadata
        order
        formFieldOptions(orderBy: ORDER_ASC, condition: { active: true }) {
          nodes {
            id
            localizedValue
            value
            order
          }
        }
      }
    }
    formFieldOptions(orderBy: ORDER_ASC, condition: { active: true }) {
      nodes {
        id
        localizedValue
        value
        order
        predefined
      }
    }
    formFieldAgreementByFormFieldId {
      agreementTextTranslatedEntity {
        ...TranslatedEntityLocalizations
      }
    }
  }
`)

export const FORM_FIELD_ENTRY_FRAGMENT_EMPLOYEES_PAGE = gql`
  fragment FormFieldEntryEmployeesPage on FormFieldEntry {
    id
    value
    formFieldId
    employeeId
    productId
    active
  }
`

export const USE_FORM_FIELD_FRAGMENT = graphql(`
  fragment UseFormField on FormField {
    id
    name
    localizedName
    fieldType
    objectType
    sensitive
    required
    multiple
    uniqueValue
    fieldGroupId
    fieldGroup {
      id
      localizedName
    }
    productTypeIds
    departmentTypeIds
    metadata
    localizedHelpText
    localizedAgreementText
    supportsFutureData
    changesMustBeApproved
    formFieldOptions(condition: { active: true }, orderBy: ORDER_ASC) {
      nodes {
        id
        localizedValue
      }
    }
    defaultValue
    formFieldEntries(filter: $fieldEntriesFilter, condition: { active: true })
      @include(if: $getFieldEntries) {
      nodes {
        id
        value
        humanReadableValue
        userId
      }
    }
  }
`)

export default FORM_FIELD_FRAGMENT
